import { dustyOrangeTwo, dustyOrangeTwoHover, fontWeight } from '~/styles';

const commonButtonStyles = `
  color: #fff;
  border-radius: 4px;
  height: 50px;
  font-size: 14px;
  font-weight: ${fontWeight.semiBold};
  line-height: 17px;
  letter-spacing: 0.1em;
  cursor: pointer;
  text-transform: uppercase;
  margin: 0;
  display: inline-flex;
  vertical-align: middle;
  text-align: center;
  padding: 2px 30px 0;
  align-items: center;
  justify-content: center;
  background-color: transparent;
  border: 2px solid transparent;
  transition: background-color 0.25s ease-in-out;
  &:hover {
    text-decoration: none;
  }
`;

export const orangeButtonStyles = `
  ${commonButtonStyles}
  background-color: ${dustyOrangeTwo};

    &:hover,
  &:focus {
    color: #fff;
    background-color: ${dustyOrangeTwoHover};
  }
`;

export const whiteOutlineButtonStyles = `
    ${commonButtonStyles}
    border: 2px solid #FFFFFF;
    &:hover,
  &:focus {
    color: #fff;
    background-color: #ffffff1f;
  }
`;
